/**
 * T250 — Subscription cancel + reactivate API.
 *
 *   cancelSubscription(id, reason)  → POST /api/subscriptions/<id>/cancel/
 *   reactivateSubscription(id)      → POST /api/subscriptions/<id>/reactivate/
 *
 * Cancel schedules end-of-period termination: service continues until
 * current_period_end, then a server cron flips to CANCELLED.
 * Reactivate undoes the schedule (only valid before period_end).
 */
import api from "./axios";

export const cancelSubscription = (id, reason = "") =>
  api.post(`/api/subscriptions/${id}/cancel/`, { reason });

export const reactivateSubscription = (id) =>
  api.post(`/api/subscriptions/${id}/reactivate/`);
